import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class ContactPerson extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get email() {
    return get(this, '_email.value', '');
  }

  get phone() {
    return get(this, '_phone.value', '');
  }

  get photo() {
    return get(this, '_photo.value[0].url', '');
  }

  get description() {
    return get(this, '_description.value', '');
  }

  get name() {
    return get(this, '_name.value', '');
  }

  get links() {
    return get(this, '_links', []);
  }

  get id() {
    return get(this, 'system.id', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/ContactPerson.model.js